import { memo, useMemo } from 'react';
import { useLegWarnings, UseLegWarningsParams } from '@lp/features/RoutePlanner/hooks/useLegWarnings';
import { useLegAircraftUtilizationWarnings } from '@lp/features/RoutePlanner/hooks/useLegAircraftUtilizationWarnings';
import { LegWarningsList } from './LegWarningsList';

export const SegmentLegWarnings = memo(({ leg, prevLeg, segment }: UseLegWarningsParams) => {
  const legWarnings = useLegWarnings({ leg, prevLeg, segment });
  const utilizationWarnings = useLegAircraftUtilizationWarnings({ leg });

  const warnings = useMemo(() => [...legWarnings, ...utilizationWarnings], [legWarnings, utilizationWarnings]);

  return <LegWarningsList warnings={warnings} />;
});
